import React, { useEffect, useState } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { API_BASE_URL } from "../../config.js";
import { FaEye } from "react-icons/fa";
import { Link } from "react-router-dom";

const AssetsList = () => {
  const [records, setRecords] = useState([]);
  const [filterText, setFilterText] = useState("");

  useEffect(() => {
    fetchAssets();
  }, []);

  const fetchAssets = async () => {
    try {
      const token = localStorage.getItem("authToken");

      const res = await axios.get(API_BASE_URL + "/assets_list", {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      const formatted = res.data.records.map((row) => ({
        assets_id: row.assets_id,
        asset_name: row.asset_name,
        category_name: row.category_name,
        asset_code: row.asset_code,
        location: row.location,
        status: row.status,
        department: row.department,
        unit_price: row.unit_price,
      }));

      setRecords(formatted);

    } catch (err) {
      console.error("Failed to load assets_list:", err);
    }
  };

  /* --------------------------------------
   * SEARCH FILTER
   * -------------------------------------- */
  const filteredItems = records.filter((item) =>
    `${item.asset_name} ${item.category_name} ${item.asset_code} ${item.location} ${item.status} ${item.department}`
      .toLowerCase()
      .includes(filterText.toLowerCase())
  );

  /* --------------------------------------
   * VIEW BUTTON
   * -------------------------------------- */
  const handleView = (row) => {
    window.location.href = `/Asset-info/${row.assets_id}`;
  };

  /* --------------------------------------
   * DATATABLE COLUMNS
   * -------------------------------------- */
  const columns = [
    {
      name: "Action",
      width: "70px",
      cell: (row) => (
        <button
          onClick={() => handleView(row)}
          className="btn p-1"
          style={{ background: "transparent", border: "none" }}
        >
          <FaEye size={16} />
        </button>
      ),
    },
    { name: "Asset Name", selector: (row) => row.asset_name, sortable: true },
    { name: "Category", selector: (row) => row.category_name, sortable: true },
    { name: "Asset Code", selector: (row) => row.asset_code, sortable: true },
    { name: "Location", selector: (row) => row.location, sortable: true },
    { name: "Status", selector: (row) => row.status, sortable: true },
    { name: "Department", selector: (row) => row.department, sortable: true },
    { name: "Unit Price", selector: (row) => row.unit_price, sortable: true },
  ];

  /* --------------------------------------
   * CLEAN CSV EXPORT (NO BLANK SPACES)
   * -------------------------------------- */
  const downloadCSV = () => {
    const headers = [
      "assets_id",
      "asset_name",
      "category_name",
      "asset_code",
      "location",
      "status",
      "department",
      "unit_price",
    ];

    const rows = filteredItems.map((row) => [
      row.assets_id,
      row.asset_name,
      row.category_name,
      row.asset_code,
      row.location,
      row.status,
      row.department,
      row.unit_price,
    ]);

    const csv =
      headers.join(",") +
      "\n" +
      rows
        .map((r) =>
          r
            .map((v) =>
              typeof v === "string"
                ? `"${v.replace(/"/g, '""')}"`
                : v ?? ""
            )
            .join(",")
        )
        .join("\n");

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "Assets_List.csv";
    link.click();
  };

  return (
    <div className="container mt-4">

      <div className="card shadow-sm">

        {/* ---------------- ADD NEW BUTTON (Top Right) ---------------- */}
        <div className="d-flex justify-content-end p-3">
          <Link to="/create-asset">
            <button className="btn btn-outline-primary btn-sm">
              <span className="ion ion-md-add"></span> Add New
            </button>
          </Link>
        </div>

        {/* ------------------ HEADER + SEARCH BOX ------------------ */}
        <div className="card-header d-flex justify-content-between align-items-center">

          <h6 className="mb-0">Assets List</h6>

          {/* RIGHT SIDE SEARCH BOX (Small Size) */}
          <input
            type="text"
            placeholder="Search..."
            className="form-control form-control-sm"
            style={{ width: "220px" }}
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
          />
        </div>

        <div className="card-body">

          {/* ------------------ CSV DOWNLOAD BUTTON ------------------ */}
          <button className="btn btn-success btn-sm mb-3" onClick={downloadCSV}>
            CSV
          </button>

          {/* ------------------ DATATABLE ------------------ */}
         <DataTable
  columns={columns}
  data={filteredItems}
  pagination
  highlightOnHover
  striped
  responsive

  // ⭐ CUSTOM PAGINATION SETTINGS
  paginationPerPage={25}
  paginationRowsPerPageOptions={[25, 50, 100]}
/>

        </div>
      </div>

    </div>
  );
};

export default AssetsList;
